import * as Sentry from '@sentry/react';
import { isProduction } from '../utils/environment';

const isTestEmail = (email: string) => email.toUpperCase().includes('YOPMAIL.COM');

export const initSentry = () => {
  if (isProduction) {
    Sentry.init({
      maxValueLength: 10000,
      tracesSampleRate: 1.0,
      enabled: true,
      dsn: 'https://b53bec84ecb9a1da3c53f1d3c8854629@o4506784579387392.ingest.sentry.io/4506784816889856',
      ignoreErrors: [
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
      ],
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      // Performance Monitoring
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      // tracePropagationTargets: ["localhost"],
      tracePropagationTargets: [],
      // Session Replay
      // tslint:disable-next-line:max-line-length
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      // tslint:disable-next-line:max-line-length
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }
};

export const sentryReport = (data: string, message: string, code: number, info?: {}, usr?: string) => {

  if (usr && isTestEmail(usr)) { return; }

  const mail = localStorage.getItem('login-email');
  if (mail && isTestEmail(mail)) { return; }

  const details = {
    info: info && {...info, path: '/login' },
  };

  const objectToSend = {
    code,
    details,
    data,
    message,
  };

  try {
    Sentry.captureException(new Error(JSON.stringify(objectToSend)));
  } catch (error) {
    Sentry.captureException(new Error(JSON.stringify(error)));
  }
};
